(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3MemberLookup', {
            templateUrl: 'app/shared/member-lookup/member-lookup.component.html',
            controller: MemberLookupComponent,
            bindings: {
                select: '&select',
                activeOnly: '<',
                excludeId: '<'
            }
        });

    var gettext = angular.identity,
        $ = angular.element;

    MemberLookupComponent.$inject = ['$scope', '$element', '$q', 'DataSource', 'Member', 'memberLookupPageSize', 'memberLookupPlaceholder', 'memberAdminResources', 'alert', 'gettextCatalog'];
    function MemberLookupComponent($scope, $element, $q, DataSource, Member, memberLookupPageSize, memberLookupPlaceholder, resources, alert, gettextCatalog) {
        var ctrl = this;

        // Properties
        ctrl.data = { data: [], total: 0 };
        ctrl.filter = { search: null };
        Object.defineProperty(ctrl.filter, 'activeOnly', { enumerable: true, get: function () { return ctrl.activeOnly; } });
        Object.defineProperty(ctrl.filter, 'excludeId', { enumerable: true, get: function () { return ctrl.excludeId; } });
        ctrl.placeholder = memberLookupPlaceholder;

        // Methods
        ctrl.$onInit = init;
        ctrl.sort = sort;
        ctrl.getColumnClass = getColumnClass;
        ctrl.getPrimaryTooltip = getPrimaryTooltip;

        //////////////////////////

        function init() {
            ctrl.dataSource = new DataSource({
                data: ctrl.data,
                read: getData,
                filter: ctrl.filter,
                pageSize: memberLookupPageSize
            });
            $scope.$watch('$ctrl.filter', filterWatchAction, true);

            // gap 5.7.2018 - This is horrible and I am ashamed of myself.
            $element[0].addEventListener('scroll', function (e) {
                if (e.target.tagName == 'TBODY') {
                    e.target.parentNode.tHead.rows[0].style.transform = 'translateX(' + -e.target.scrollLeft + 'px)';
                }
            }, true);
        }

        function getData(options) {
            var search = options.$filter.search;
            return search ? Member.adminSearch(options, success, error, true) : $q.resolve({ data: [], total: 0 });

            function success(data) {
                ctrl.data = data;
            }

            function error(rejection) {
                var isCancellation = rejection && rejection.status === -1;
                if (!isCancellation)
                    alert.error(resources.memberLookupRequestFailed);
            }
        }

        function sort(field) {
            var dataSource = ctrl.dataSource,
                sort = dataSource.sort;
            dataSource.sort = !sort || sort.field !== field ? { field: field, dir: 'asc' } : sort.dir === 'asc' ? { field: field, dir: 'desc' } : null;
        }

        function filterWatchAction(newVal, oldVal) {
            if (oldVal != newVal) {
                ctrl.dataSource.page = 1;
            }
        }

        function getColumnClass(field) {
            var sort = ctrl.dataSource.sort;
            return sort && sort.field === field ? sort.dir === 'desc' ? 'sort-link-desc' : 'sort-link-asc' : null;
        }

        function getPrimaryTooltip(isPrimary) {
            return isPrimary ? gettextCatalog.getString(gettext('Primary Membership')) : gettextCatalog.getString(gettext('Secondary Membership'));
        }
    }
})();